import { render, staticRenderFns } from "./h3.vue?vue&type=template&id=8ccdb06c&"
import script from "./h3.vue?vue&type=script&lang=js&"
export * from "./h3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports